<!--<div class="question-skip">
<label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
  <input type="checkbox" [checked]="checked" #skipquestion (change)="onChange(skipquestion.checked)" name="skip-happened-happened" id="skip-happened-happened">
  <span class="custom-toggle__indi"></span>
  <span class="custom-toggle__label">Skip for now</span>
</label>
</div>-->

<div class="question-stepper">
  <div class="question-stepper__img question-stepper__img--avatar">
    @if (class_name) {
      <img [src]="'assets/icn/70px-' + class_name + '.svg'" class="icon"/>
    }
    @if (!class_name) {
      <img  [src]="'assets/icn/70px-personal-accident.svg'" class="icon"/>
    }
    <img [src]="'assets/' + session_details?.category_id + '/icn/claims-shield.svg'" class="icon-secondary"/>
  </div>
  <div class="question-stepper__content">
    <h3 class="font-normal" [innerHTML]="question?.question_copy">
    </h3>
    <div class="question-skip">
      <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
        <input type="checkbox"
          [checked]="checked"
          [(ngModel)]="checked"
          (change)="onChange()"
          name="skip-happened-happened" id="skip-happened-happened">
          <span class="custom-toggle__indi"></span>
          <span class="custom-toggle__label">Skip for now</span>
        </label>
      </div>
    </div>
  </div>

  <div class="question question-pull">
    @for (option of options; track option) {
      <div class="note note--md note--info mb-4">
        <div class="note__icon note__icon--everything">
          <svg class="icon">
            <use xlink:href="#success-small"></use>
          </svg>
        </div>
        <div class="note__content" [innerHTML]="option?.answer"></div>
      </div>
    }
  </div>
